module.exports = __webpack_public_path__ + "assets/media/1.4f20240b.wav";